<template>
  <div class="activitiesManage">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-activitiesManage">
          <div class="head-tab--nav">
            <div class="head-nav h-3 clearFloat">
              <span class="c-normal">跨界活动名单</span>
              <div class="pull-right">
                <el-button type="primary" @click="daochu">{{
                  $t("Common.btn_export")
                }}</el-button>
              </div>
            </div>
          </div>
          <div class="activitiesManage-container">
            <div class="content">
              <div v-if="tableDataList.length <= 0" class="flex-wrap">
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666">创建时间：</span>
                  <div class="time-box flex-al">
                    <!-- <el-date-picker
                      type="date"
                      :placeholder="$t('Crmactivemanage.ad')"
                      v-model="selectForm.activity_startdate"
                      value-format="yyyy-MM-dd"
                      @change="handleSelect()"
                      style="width: 140px"
                    ></el-date-picker>
                    <span class="ml10 mr10 fs14">{{
                      $t("Crmactivemanage.ae")
                    }}</span>
                    <el-date-picker
                      type="date"
                      :placeholder="$t('Crmactivemanage.af')"
                      v-model="selectForm.activity_enddate"
                      style="width: 140px"
                      value-format="yyyy-MM-dd"
                      @change="handleSelect()"
                    ></el-date-picker> -->
                    <el-date-picker
                      style="width: 250px;"
                      @change="handleSelect"
                      v-model="selectForm.rangeTime"
                      type="daterange"
                      value-format="yyyy-MM-dd"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    >
                    </el-date-picker>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666">是否结算 ：</span>
                  <div class="select-box" style="width: 160px">
                    <el-select
                      @change="selectSearch"
                      @clear="selectSearch"
                      v-model="selectForm.activity_is_amount"
                      clearable
                      filterable
                      placeholder="请选择是否结算"
                    >
                      <el-option
                        v-for="item in record_settlementstatusList"
                        :key="item.record_settlementstatus"
                        :label="item.record_settlementstatus_name"
                        :value="item.record_settlementstatus"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div
                v-if="tableDataList.length > 0"
                class="flex-wrap"
                style="margin-bottom: 10px;"
              >
                <el-button type="primary" @click="handleAllSettlement"
                  >批量结算</el-button
                >
              </div>
              <div class="tableList" ref="auto_height_table">
                <reserveTable
                  :tableData="tableDatas"
                  @handleSelectionChange="handleSelectionChange"
                >
                  <el-table-column
                    label="操作"
                    align="center"
                    width="100px"
                    fixed="right"
                  >
                    <template slot-scope="scope">
                      <el-button
                        v-if="scope.row.record_settlementstatus == 0"
                        type="text"
                        @click="settlementBtn(scope.row)"
                        >结算</el-button
                      >
                      <el-button v-else type="text" disabled>结算</el-button>
                    </template>
                  </el-table-column>
                </reserveTable>
              </div>
              <el-pagination
                style="margin-top: 35px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataNumber"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>

    <el-dialog
      title="结算"
      :visible.sync="SettlementDialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delete-tips tc">
          是否确认结算<span style="color: #20a8d8">{{ user_name }}</span
          >的中奖金额<span style="color: #20a8d8">{{
            record_winningamount
          }}</span
          >元？
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SettlementDialogVisible = false">{{
          $t("Crmactivemanage.bb")
        }}</el-button>
        <el-button type="primary" @click="handleSettlement">{{
          $t("Crmactivemanage.bc")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="是否确认批量结算中奖金额"
      :visible.sync="AllSettlementDialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <el-table
          ref="multipleTableDevice"
          :data="tableDataList"
          border
          fit
          @selection-change="selectChange"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            label="姓名"
            align="center"
            prop="user_name"
          ></el-table-column>
          <el-table-column
            label="金额"
            align="center"
            prop="record_winningamount"
          ></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <span style="position: absolute;left: 15px; font-size: 14px;"
          >共计：{{ sum }} 元</span
        >
        <el-button @click="AllSettlementDialogVisible = false">{{
          $t("Crmactivemanage.bb")
        }}</el-button>
        <el-button type="primary" @click="handleConfirm">{{
          $t("Crmactivemanage.bc")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- <div class="customModel" v-if="customModelVisible"></div> -->
    <div class="customFather" v-if="customModelVisible2">
      <div class="customChild">
        <span class="customInfo"
          >您已经成功结算<span style="color: #20a8d8">{{ record_num }}</span
          >条名单，共<span style="color: #20a8d8">{{
            record_settlementamount
          }}</span
          >元</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import PageNav from "@/components/Nav/nav.vue";
import SliderBox from "@/components/SliderBox";
import reserveTable from "@/components/Table/reserveTable.vue";
import activeTeamp from "@/components/Activity/active.vue";
import CrmActiveManage from "../Crmactivemanage/crmActiveManage.js";
export default {
  name: "Activitiesmanage-activitiesManage",
  data() {
    return {
      // customModelVisible: false,
      customModelVisible2: false,
      sum: 0,
      record_num: 0,
      record_settlementamount: 0,
      tableDataList: [],
      record_settlementstatusList: [
        {
          record_settlementstatus: 0,
          record_settlementstatus_name: "否",
        },
        {
          record_settlementstatus: 1,
          record_settlementstatus_name: "是",
        },
      ],
      user_name: "",
      record_winningamount: "", // 中奖金额
      tableDatas: {
        list: [],
        columns: [],
        options: {
          mutiSelect: true,
          tableHeight: null, //表格高度
          errortip: "",
        },
      },
      record_json: [],
      record_json2: [],
      SettlementDialogVisible: false,
      AllSettlementDialogVisible: false,
      openMenu: ["1"],
      showSliderBoxCreate: false,
      showSliderBoxEdit: false,
      showSliderBoxSee: false,
      currentPage: 1,
      dialogVisible: false,
      PreviewVisible: false, //活动模板预览图
      DelVisible: false, //删除
      copyItem: false, //复制
      fullscreenLoading: true, //全屏loading
      goalId: "",
      onCodeInfo: {
        oneCodeImg: "", //单个活动的二维码
        oneCodeWxImg: "", //单个活动的二维码---微信
        oneCodeUrl: "", //单个活动的url
      },

      ActivitytempOne: {}, //单个模板信息
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      basicinformation: [],
      creatimageUrl: "",
      imageUrl: "",
      dialogimgVisible: false,
      input: "",
      select: "",
      sliderWidth: "800px",
      sliderSeeWidth: "450px",
      activeName: "first",
      activeName1: "first",
      activityId: "", //暂存查看的活动id
      activeOne: {}, //单个活动信息
      infoForm: {
        a_content: "",
        editorOption: {},
      },
      //富文本编辑器
      defaultMsg: this.$t("Crmactivemanage.bd"),
      config: {
        initialFrameWidth: null,
        initialFrameHeight: 350,
      },
      //筛选条件
      selectForm: {
        rangeTime: "",
        activity_is_amount: "",
        activity_startdate: "",
        activity_enddate: "",
        // found_marketer_id: "",
        // activity_pattern: "", //活动类型
        // channel_id: "", //渠道明细
        // frommedia_name: "", //渠道类型
        // keyword: "",
      },
      //创建人
      founder: [],
      SourceList: [], //选择渠道类型-下拉数据
      ChannelList: [], //选择渠道明细-下拉数据
      // 发布活动
      aciveCreateInfo: {
        aciveText: this.$t("Crmactivemanage.be"),
        aciveClass: "silder-contain-creat",
      },
      // 编辑活动
      aciveEditInfo: {
        aciveText: this.$t("Crmactivemanage.bf"),
        aciveClass: "silder-contain-edit",
      },

      // optionscaozuo: {
      //   tableHeight: null,
      // }
    };
  },
  components: {
    PageNav,
    SliderBox,
    activeTeamp,
    reserveTable,
  },
  updated() {
    this.fullscreenLoading = false;
  },
  created() {
    console.warn(this.$route.query);
    
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";
    this.re_postbe_id = this.$Tool.getStorage("re_postbe_id")
      ? this.$Tool.getStorage("re_postbe_id")
      : "";
    this.language_type = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "";
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    this.languageType = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "zh";
    this.activityRecordList();
    // this.optionscaozuo.tableHeight = this.$Common.getTableHeight(310); //设置表格高度
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  methods: {
    // 筛选
    selectSearch() {
      this.tableDatas.list = [];
      this.activityRecordList();
    },
    // 总计
    handleSum() {
      this.sum = 0;
      this.tableDataList.map((item) => {
        return (this.sum += parseFloat(item.record_winningamount));
      });
    },
    selectChange(val) {
      this.sum = 0;
      
      this.record_json = val.map((item) => ({
        record_id: item.record_id,
      }));
      val.map((item) => {
        return (this.sum += parseFloat(item.record_winningamount));
      });
    },
    // 结算btn
    settlementBtn(row) {
      (() => {})(row);
      const { user_name, record_winningamount, record_id } = row;
      this.user_name = user_name;
      this.record_winningamount = record_winningamount;
      // let arr = [];
      // arr.push({record_id: record_id});
      this.record_json2 = [
        {
          record_id: record_id,
        },
      ];
      // this.record_json2.push({"record_id":record_id});
      // this.record_json = [{record_id: record_id}]
      this.SettlementDialogVisible = true;
    },
    handleSelectionChange(val) {
      
      this.tableDataList = val;
      this.record_json = val.map((item) => {
        return {
          record_id: item.record_id,
        };
      });
      console.warn(this.record_json);
    },
    // 批量结算btn
    handleAllSettlement() {
      (() => {})("批量结算");
      this.sum = 0;
      this.handleSum();
      this.$nextTick(() => {
        for (let i = 0; i < this.tableDataList.length; i++) {
          this.$refs.multipleTableDevice.toggleRowSelection(
            this.tableDataList[i],
            true
          );
        }
      });
      this.AllSettlementDialogVisible = true;
    },
    // 结算提交
    handleSettlement() {
      this.batchSettlementAction(this.record_json2);
      this.SettlementDialogVisible = false;
    },
    // 批量结算提交
    handleConfirm() {
      this.batchSettlementAction(this.record_json);
      this.AllSettlementDialogVisible = false;
    },
    // CRM-活动参与列表
    activityRecordList() {
      CrmActiveManage.activityRecordList({
        activity_id: this.$route.query.activity_id, // 活动id
        p: this.currentPage,
        num: this.pagesize,
        is_count: "1", // 是否需要总数
        activity_is_amount: this.selectForm.activity_is_amount, // 是否结算
        activity_startdate: this.selectForm.rangeTime
          ? this.selectForm.rangeTime[0]
          : "",
        activity_enddate: this.selectForm.rangeTime
          ? this.selectForm.rangeTime[1]
          : "",
      }).then((res) => {
        (() => {})(res);
        const { code, msg, data: body } = res.data;
        const r = body;
        this.tableDatas.columns = r.field;
        this.dataNumber = r.data.allnum;
        if (code === 200) {
          this.tableDatas.list = r.data.datalist;
        } else {
          this.tableDatas.list = [];
          this.tableDatas.options.errortip = msg;
        }
      });
    },
    batchSettlementAction(record_json) {
      (() => {})(record_json);
      CrmActiveManage.batchSettlementAction({
        record_json: JSON.stringify(record_json),
      }).then((res) => {
        (() => {})(res);
        const { code } = res.data;
        if (code === 200) {
          this.activityRecordList();
          this.record_num = res.data.data.data.record_num;
          this.record_settlementamount =
            res.data.data.data.record_settlementamount;
          this.customModelVisible2 = true;
          setTimeout(() => {
            this.customModelVisible2 = false;
          }, 3000);
        }
      });
    },
    handleAdd() {
      this.showSliderBoxCreate = true;
    },
    hideSliderBox() {
      this.showSliderBoxCreate = false;
    },

    // 选择查询
    handleSelect() {
      this.currentPage = 1;
      this.tableDatas.list = [];
      this.activityRecordList();
    },
    // 招生渠道类型筛选
    // frommediaSearch() {
    //   this.currentPage = 1;
    //   this.selectForm.channel_id = "";
    //   this.getChannelApi(); // 获取渠道明细

    // },
    // 输入关键词查询
    handleSelectKeyword() {
      this.currentPage = 1;
    },
    // 点击名字查看单个员工
    handleColumnChange(k, v) {
      (() => {})(v, k);
      this.activityId = v.activity_id;
      this.activeOne = v;
      this.showSliderBoxSee = true;
      // this.getgoalActivityOneData(v.activity_id);
    },
    // 点击查看里的编辑
    handClickEdit() {
      this.showSliderBoxSee = false;
      this.showSliderBoxEdit = true;
    },
    onEditorReady(editor) {
      (() => {})(editor);
    },
    // 预览模版******新建
    perviewTemp(v) {
      this.PreviewVisible = true;
      v.activitytemp_styleimg_url = v.activitytemp_styleimg;
      this.ActivitytempOne = v;
    },
    // 查看预览图******新建
    perviewSeeTemp(v) {
      this.PreviewVisible = true;
      v.activitytemp_styleimg_url = v.activitytemp_bannerimg;
      this.ActivitytempOne = v;
    },
    // 预览模版******编辑
    perviewTempEdit(v) {
      this.PreviewVisible = true;
      v.activitytemp_styleimg_url = v.activitytemp_styleimg;
      this.ActivitytempOne = v;
    },
    // 查看预览图******编辑
    perviewSeeTempEdit(v) {
      this.PreviewVisible = true;
      v.activitytemp_styleimg_url = v.activitytemp_bannerimg;
      this.ActivitytempOne = v;
    },
    // 关闭活动模板预览图
    handleClosePreview() {
      this.PreviewVisible = false;
    },
    hideSliderBoxCreate() {
      this.showSliderBoxCreate = false;
    },
    hideSliderBoxEdit() {
      this.showSliderBoxEdit = false;
    },
    hideSliderBoxSee() {
      this.showSliderBoxSee = false;
    },
    handleDel() {
      this.dialogVisible = true;
    },
    handleClose(done) {
      done();
      // this.$confirm(this.$t("Crmactivemanage.bo"))
      //   .then((_) => {
      //     (() => {})(_);
      //     done();
      //   })
      //   .catch((_) => {
      //     (() => {})(_);
      //   });
    },
    handleSizeChange(val) {
      (() => {})(`每页 ${val} 条`);
      this.pagesize = val;
      this.activityRecordList();
    },
    handleCurrentChange(val) {
      (() => {})(`当前页: ${val}`);
      this.currentPage = val;
      this.activityRecordList();
    },
    // 导出操作
    daochu() {
      let params_str = "",
        is_export = 1;
      // for (name in this.selectForm) {
      //   if (name != "rang_time") {
      //     // 时间范围不需要
      //     params_str = params_str + `&${name}=${this.selectForm[name]}`;
      //   }
      // }
      let url = CrmActiveManage.activityRecordList1();
      params_str = `${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&re_postbe_id=${this.re_postbe_id}&postbe_crmuserlevel=${this.postbe_crmuserlevel}&language_type=${this.language_type}&is_export=${is_export}&activity_id=${this.$route.query.activity_id}`;
      (() => {})(params_str);
      if (this.tableDatas.list.length > 0) {
        window.open(this.$buildExportUrl(params_str), "_blank");
      } else {
        this.$message.error(this.$t("Common.exportTips"));
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.tableDatas.options.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 90
        );
      }
    });
  },
};
</script>

<style lang="less">
@import url("../../assets/less/manage.less");
@import url("crmActiveManage.less");

.activitiesManage {
  height: 100vh;
  font-size: 20px;

  .code-img {
    width: 100%;
    display: flex;
    justify-content: space-between;

    > div {
      flex: 1;

      img {
        width: 165px !important;
        height: 165px;
      }
    }

    .left {
      margin-right: 10px;

      .one-img {
        width: 220px;
        height: 220px;
        padding-top: 13px;
      }

      .one-tw-img {
        width: 300px;
        height: 300px;
        margin: 0 auto;

        img {
          width: 100% !important;
          height: 100%;
        }
      }
    }

    .right {
      margin-left: 10px;
    }

    iframe {
      * {
        margin: 0 !important;
        padding: 0 !important;
      }
    }
  }

  .customModel {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.5;
    z-index: 2016 !important;
  }

  .customFather {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    z-index: 2017 !important;

    .customChild {
      position: absolute;
      margin: auto;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: inline-block;
      width: 420px;
      height: 180px;
      padding-bottom: 10px;
      vertical-align: middle;
      background-color: #fff;
      border-radius: 4px;
      border: 1px solid #ebeef5;
      font-size: 18px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      text-align: left;
      overflow: hidden;
      backface-visibility: hidden;

      .customInfo {
        display: block;
        text-align: center;
        line-height: 180px;
      }
    }
  }
}
</style>
